import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ErrorBoundary from "./pages/ErrorBoundary";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import HomePage from "./components/Home";
import ProfilePage from "./pages/ProfilePage";
import { clearAuthSession, getValidToken } from "./services/api";

const PrivateRoute = ({ children }) => {
  const token = getValidToken();
  if (!token) {
    clearAuthSession();
    return <Navigate to="/login" replace />;
  }
  return children;
};

const RedirectToTab = ({ tab }) => (
  <PrivateRoute>
    <Navigate to={tab === "beranda" ? "/" : `/?tab=${tab}`} replace />
  </PrivateRoute>
);

export default function App() {
  return (
    <ErrorBoundary>
      <Router>
        <ToastContainer
        position="top-right"
        autoClose={3500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="colored"
      />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/menulis" element={<RedirectToTab tab="rancang" />} />
        <Route path="/desain" element={<RedirectToTab tab="desain" />} />

        <Route
          path="/"
          element={
            <PrivateRoute>
              <HomePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile/:userId"
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
    </ErrorBoundary>
  );
}
